import React, { useState } from 'react'
import { ScoreCardInitialData } from '../types/interface'


const initialData: ScoreCardInitialData = {
    reviewedScore: false,
    totalComments: 0,
    isReviewSubmitted: false,
    scores: {},
    customerEffortAssesment: {},
    activeSection: 0,
    updateScores: (scores) => {},
    updateReviewedScore: (reviewedScore) => {},
    updateTotalComments: (updateTotalComments) => {},
    updateActiveSection: (idx) => {},
    updateCustomerEffortAssesment: (data) => {},
    setDefault: () => {}
}

export const ScoreCardContext = React.createContext(initialData)

const ScoreCardContextProvider = (props: any) => {

    const [scores, setScores] = useState<any>(initialData.scores)
    const [reviewedScore, setReviewedScore] = useState<boolean>(initialData.reviewedScore)
    const [isReviewSubmitted, setIsReviewSubmitted] = useState<boolean>(initialData.isReviewSubmitted)
    const [totalComments, setTotalComments] = useState(initialData.totalComments)
    const [activeSection, setActiveSection] = useState(initialData.activeSection)
    const [customerEffortAssesment, setCustomerEffortAssesment] = useState(initialData.customerEffortAssesment)

    const updateScoresHandler = (scores: any = initialData.scores) => {
        setScores(scores)
    }

    const setReviewedScoreHandler = (reviewedScore: boolean = initialData.reviewedScore) => {
        setReviewedScore(reviewedScore)
    }
    
    const setIsReviewSubmittedHandler = (isReviewSubmitted: boolean = false) => {
        setIsReviewSubmitted(isReviewSubmitted)
    }

    const setTotalCommentsHandler = (totalComments: number = 0) => {
        setTotalComments(totalComments)
    }

    const updateActiveSection = (idx: number) => {
        setActiveSection(idx)
    }

    const updateCustomerEffortAssesmentHandler = (data: any = initialData.customerEffortAssesment) => {
        setCustomerEffortAssesment(data)
    }

    const setDefaultHandler = () => {
        updateScoresHandler()
    }

    const contextValue = {
        reviewedScore: reviewedScore,
        scores: scores,
        isReviewSubmitted: isReviewSubmitted,
        totalComments: totalComments,
        activeSection,
        customerEffortAssesment,
        updateScores: updateScoresHandler,
        updateReviewedScore: setReviewedScoreHandler,
        updateTotalComments: setTotalCommentsHandler,
        setDefault: setDefaultHandler,
        updateActiveSection: updateActiveSection,
        updateCustomerEffortAssesment: updateCustomerEffortAssesmentHandler,
    }

    return (
        <ScoreCardContext.Provider value={contextValue}>
            {props.children}
        </ScoreCardContext.Provider>
    )
}

export default ScoreCardContextProvider
